import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import { Grid, GridItem } from '../../grid'
import Input from '../../input'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import {showAdditionalChargePanel} from '../../../utils/jewelry-validation'

class AdditionalChargePanel extends Component {
  render () {
    const props = this.props
    const getAdditionalPriceCurrency = () => {
      return [
        {value: 'usd', label: 'USD'},
        {value: 'cad', label: 'CAD', disabled: props.sessionCurrency === 'usd'}
      ]
    }
    return (
      <JewelryPanel
        id='AdditionalChargePanel'
        show={showAdditionalChargePanel(props)}>
        <h4 id='additional_charge_title'>Additional Charge</h4>
        <Grid>
          <GridItem col='7/8'>
            <Input
              type='number'
              step={0.01}
              value={props.additional_price}
              placeholder='$'
              onChange={props.onChangeVal.bind(this, 'additional_price')} />
          </GridItem>
          <GridItem col='1/8'>
            <SelectItem
              id='additional_price_currency'
              label=''
              labelId='additional_price_currency'
              options={getAdditionalPriceCurrency()}
              value={props.additional_price_currency}
              onChange={props.onChangeVal.bind(this, 'additional_price_currency')} />
          </GridItem>
        </Grid>

        <Spacer xxs />

        <h4>Additional Notes</h4>
        <Input
          inputId={'additional_notes'}
          value={props.additional_notes}
          placeholder=''
          onChange={props.onChangeVal.bind(this, 'additional_notes')}
        />
      </JewelryPanel>
    )
  }
}

export default AdditionalChargePanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/additional-charge-panel/index.js